import React, { useState, useEffect } from 'react';

// project-imports
import { useEnquiryContext } from '../../context/enquiry_context';
import { GoogleAnalyticsEnum, triggerFunction } from '../../utils/google-analytics';
import { useSelector } from 'react-redux';
import { isBlockedDomain, isBlockedMobileNo, isBlockedLinkedInId } from '../../utils';

// Reading environment variables
const INVALID_NAME_ERROR_MESSAGE = process.env.REACT_APP_INVALID_FULLNAME_ERROR_MESSAGE;
const INVALID_EMAIL_ERROR_MESSAGE = process.env.REACT_APP_INVALID_EMAIL_ERROR_MESSAGE;
const INVALID_PHONE_NO_ERROR_MESSAGE = process.env.REACT_APP_INVALID_PHONE_NO_ERROR_MESSAGE;
const INVALID_LINKED_IN_URL_ERROR_MESSAGE = process.env.REACT_APP_INVALID_LINKEDIN_URL_ERROR_MESSAGE;
const NAME_ERROR_MESSAGE = process.env.REACT_APP_NAME_ERROR_MESSAGE;
const EMAIL_ERROR_MESSAGE = process.env.REACT_APP_EMAIL_ERROR_MESSAGE;
const LINKED_IN_URL_ERROR_MESSAGE = process.env.REACT_APP_LINKEDIN_URL_ERROR_MESSAGE;
const PHONE_NO_ERROR_MESSAGE = process.env.REACT_APP_PHONE_NO_ERROR_MESSAGE;
const DESCRIPTION_ERROR_MESSAGE = process.env.REACT_APP_TOPIC_DESCRIPTION_ERROR_MESSAGE;
const RATING_ERROR_MESSAGE = process.env.REACT_APP_RATING_ERROR_MESSAGE;


// Success Message Component
const Result = () => (
    <p className="success-message">Thanks for submitting your review. We'll look into this and publish on the website after review.</p>
);

const ratingOptions = [
    { key: "select rating", label: "none", value: 0 },
    { key: "1", label: "Poor", value: 1 },
    { key: "2", label: "Fair", value: 2 },
    { key: "3", label: "Good", value: 3 },
    { key: "4", label: "Very Good", value: 4 },
    { key: "5", label: "Excellent", value: 5 }
]

function Testimonial({ formStyle = "rnt-contact-form rwt-dynamic-form row checkout-page-style", closeForm, type, data }) {

    // Reading Context methods and variables
    const { submitEnquiry: submitTestimonial, isLoading } = useEnquiryContext();
    const { loginData } = useSelector((item) => item.user);

    // Constant variable
    const patterns = {
        name: /^[A-Z][a-zA-Z]*((\s[A-Z][a-zA-Z]*)*){3,50}$/,
        email: /^[a-zA-Z0-9!#$%&*+=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&*=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9]{2,}(?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/,
        phone: /^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/,
        linkedIn: /(https?)?:?(\/\/)?(([w]{3}||\w\w)\.)?linkedin.com(\w+:{0,1}\w*@)?(\S+)(:([0-9])+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/,
        message: /^[\w\s!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]{3,500}$/,
        rating: /^[1-5]$/,
    };
    const currentMember = loginData && loginData.data && loginData.data?.userId ? loginData.data : {};

    // Local stat initialization
    const [result, setResult] = useState(false);
    const [newTestimonial, setNewTestimonial] = useState({
        name: currentMember && currentMember?.userFullName ? currentMember?.userFullName : '',
        email: currentMember && currentMember?.userId ? currentMember?.userId : '',
        phone: null,
        linkedIn: null,
        message: '',
        rating: ''
    });
    const [inputValidationErrors, setInputValidationErrors] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
        linkedIn: "",
        rating: ""
    });

    // Constant functions
    // Validation handler
    const validateField = (data, name) => {
        try {
            // const isValid = patterns[name].test(data[name]?.value);
            let validationObj = {};
            if (name === "name" || name === "all") {
                if (data && (!data.name || (data.name && !data.name.length))) {
                    validationObj.name = "Full Name is required!"
                } else if (data && data.name && (data?.name?.length < 3 || data?.name?.length > 50)) {
                    validationObj.name = "Full Name must be 3-50 characters long!";
                } else if (data && data.name && !(patterns["name"].test(data?.name))) {
                    validationObj.name = NAME_ERROR_MESSAGE;
                } else if (data && data.name && isBlockedDomain(data?.name)) {
                    validationObj.name = INVALID_NAME_ERROR_MESSAGE;
                } else {
                    validationObj.name = "";
                }
            }
            if (name === "email" || name === "all") {
                if (data && (!data.email || (data.email && !data.email.length))) {
                    validationObj.email = "Email is required!"
                } else if (data && data.email && !(patterns["email"].test(data?.email))) {
                    validationObj.email = EMAIL_ERROR_MESSAGE;
                } else if (data && data.email && isBlockedDomain(data?.email)) {
                    validationObj.email = INVALID_EMAIL_ERROR_MESSAGE;
                } else {
                    validationObj.email = "";
                }
            }

            if (name === "phone" || name === "all") {
                if (data && (!data.phone || (data.phone && !data.phone.length))) {
                    validationObj.phone = "Mobile No is required!"
                } else if (data && data.phone && !(patterns["phone"].test(data?.phone))) {
                    validationObj.phone = PHONE_NO_ERROR_MESSAGE;
                } else if (data && data.phone && isBlockedMobileNo(data?.phone)) {
                    validationObj.phone = INVALID_PHONE_NO_ERROR_MESSAGE;
                } else {
                    validationObj.phone = "";
                }
            }

            if (name === "linkedIn" || name === "all") {
                if (data && (!data.linkedIn || (data.linkedIn && !data.linkedIn.length))) {
                    validationObj.linkedIn = "LinkedIn URL is required!"
                } else if (data && data.linkedIn && !(patterns["linkedIn"].test(data?.linkedIn))) {
                    validationObj.linkedIn = LINKED_IN_URL_ERROR_MESSAGE;
                } else if (data && data.linkedIn && isBlockedLinkedInId(data?.linkedIn)) {
                    validationObj.linkedIn = INVALID_LINKED_IN_URL_ERROR_MESSAGE;
                } else {
                    validationObj.linkedIn = "";
                }
            }

            if (name === "message" || name === "all") {
                if (data && (!data.message || (data.message && !data.message.length))) {
                    validationObj.message = "Testimonial Description is required!"
                } else if (data && data.message && !(patterns["message"].test(data?.message))) {
                    validationObj.message = DESCRIPTION_ERROR_MESSAGE;
                } else {
                    validationObj.message = "";
                }
            }

            if (name === "rating" || name === "all") {
                if (data && (!data.rating || (data.rating && Number(data.rating) === 0))) {
                    validationObj.rating = "Rating is required!"
                } else if (data && data.rating && !(patterns["rating"].test(Number(data.rating)))) {
                    validationObj.rating = RATING_ERROR_MESSAGE;
                } else {
                    validationObj.rating = "";
                }

            }

            setInputValidationErrors((prev) => ({ ...prev, ...validationObj }));
            return validationObj;
        } catch (error) {
            console.log("126 : Testimonial : Error while checking validation :", error && JSON.stringify(error));
            throw error;
        }
    };

    const handleChange = (e) => {
        try {
            const { name, value } = e.target;

            const data = {
                [name]: value
            };

            setInputValidationErrors((prev) => ({ ...prev, ...validateField(data, name) }));
            setNewTestimonial((prev) => ({ ...prev, ...data }));
        } catch (error) {
            console.log("142 : testimonial : Error while changing value :", error && JSON.stringify(error));
            throw error;
        }
    };

    const handleSubmitTestimonial = async () => {
        try {

            let isFormValid = true;
            const valid = validateField(newTestimonial, "all");

            if (valid.name || valid.email || valid.message || valid.phone || valid.linkedIn || valid.rating) {
                isFormValid = false;
            }

            if (isFormValid) {

                const isAnyFieldEmpty = Object.values(newTestimonial).some((val) => !val.trim());
                const hasValidationErrors = Object.values(inputValidationErrors).some((error) => error);

                if (isAnyFieldEmpty || hasValidationErrors) {
                    return;
                }

                let newTestimonialRequestPayload = { ...newTestimonial };
                delete newTestimonialRequestPayload["linkedIn"];
                delete newTestimonialRequestPayload["rating"];

                // newTestimonial["phone"] = "8000000000";
                newTestimonialRequestPayload["subject"] = "Testimonial from website";
                newTestimonialRequestPayload["additionalDetails"] = JSON.stringify({ ...data, linkedIn: newTestimonial["linkedIn"], ratings: newTestimonial["rating"] });
                await submitTestimonial(newTestimonialRequestPayload);
                triggerFunction(GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.SUGGEST_TOPIC_FORM_SUBMIT_BUTTON);

                // e.target.reset();
                setNewTestimonial({
                    name: currentMember && currentMember?.userFullName ? currentMember?.userFullName : '',
                    email: currentMember && currentMember?.userId ? currentMember?.userId : '',
                    phone: "",
                    message: "",
                    linkedIn: "",
                    rating: ""
                });
                setResult(true);
            }
        } catch (error) {
            console.log("186 : Testimonial : Error while submitting suggestion :", error && JSON.stringify(error));
            throw error;
        }
    };

    // Reset result message after 2s
    useEffect(() => {
        if (result) {
            const timer = setTimeout(() => setResult(false), 2000);
            return () => { clearTimeout(timer); closeForm && closeForm(); };
        }
    }, [result]);

    return (
        <div className={formStyle}>
            <div className="col-lg-12">
                <div className="form-group">
                    <label htmlFor='name'>Enter Full Name*</label>
                    <input
                        disabled={isLoading || (currentMember && currentMember?.userId)}
                        type="text"
                        value={newTestimonial?.name || ""}
                        name="name"
                        id="name"
                        placeholder="Full Name"
                        className="form-control form-control-lg"
                        onChange={handleChange}
                        autoFocus
                        title="Please enter your name"
                    />
                    {inputValidationErrors && inputValidationErrors.name && (
                        <div className="invalid-data">{inputValidationErrors.name}</div>
                    )}
                </div>
            </div>

            <div className="col-lg-12">
                <div className="form-group">
                    <label htmlFor='email'>Enter Email Address*</label>
                    <input
                        disabled={isLoading || (currentMember && currentMember?.userId)}
                        type="email"
                        name="email"
                        id="email"
                        value={newTestimonial?.email || ""}
                        placeholder="Email"
                        className="form-control form-control-lg"
                        onChange={handleChange}
                        title="Please enter a valid email"
                    />
                    {inputValidationErrors && inputValidationErrors.email && (
                        <div className="invalid-data">{inputValidationErrors.email}</div>
                    )}
                </div>
            </div>

            <div className="col-lg-12">
                <div className="form-group">
                    <label htmlFor='phone'>Enter Mobile Number*</label>
                    <input
                        disabled={isLoading}
                        type="tel"
                        name="phone"
                        id="phone"
                        value={newTestimonial?.phone || ""}
                        placeholder="Mobile Number"
                        className="form-control form-control-lg"
                        onChange={handleChange}
                        title="Please enter a valid mobile number"
                    />
                    {inputValidationErrors && inputValidationErrors.phone && (
                        <div className="invalid-data">{inputValidationErrors.phone}</div>
                    )}
                </div>
            </div>

            <div className="col-lg-12">
                <div className="form-group">
                    <label htmlFor='linkedIn'>Enter LinkedIn Profile URL*</label>
                    <input
                        disabled={isLoading}
                        type="url"
                        name="linkedIn"
                        id="linkedIn"
                        value={newTestimonial?.linkedIn || ""}
                        placeholder="LinkedIn Profile URL"
                        className="form-control form-control-lg"
                        onChange={handleChange}
                        title="Please enter a valid LinkedIn Profile Url"
                    />
                    {inputValidationErrors && inputValidationErrors.linkedIn && (
                        <div className="invalid-data">{inputValidationErrors.linkedIn}</div>
                    )}
                </div>
            </div>


            <div className="col-lg-12">
                <div className="form-group">
                    <label htmlFor='rating'>Rate Us*</label>
                    <select name="rating" defaultValue={"select rating"} disabled={isLoading} onChange={handleChange}>
                        {ratingOptions &&
                            ratingOptions?.length &&
                            (ratingOptions || [])?.map((option) => (
                                <option value={option?.value}>
                                    {
                                        option?.key === "select rating" ?
                                            <label className="ml-3 form-check-label fw-medium text-start d-flex">
                                                <span>
                                                    {option?.label}
                                                </span>
                                            </label> :
                                            <label className="ml-3 form-check-label fw-medium text-start d-flex">
                                                <span>
                                                    {option?.key}
                                                </span>

                                                <span className="plr--5">
                                                    -
                                                </span>
                                                <span>
                                                    {option?.label}
                                                </span>
                                            </label>
                                    }

                                </option>
                            ))}
                    </select>
                    {inputValidationErrors && inputValidationErrors.rating && (
                        <div className="invalid-data">{inputValidationErrors.rating}</div>
                    )}
                </div>
            </div>


            <div className="col-lg-12">
                <div className="form-group">
                    <label htmlFor='message'>Review Description*</label>
                    <textarea
                        disabled={isLoading}
                        name="message"
                        id="message"
                        value={newTestimonial?.message || ""}
                        placeholder="Write detailed testimonial here"
                        className="form-control"
                        onChange={handleChange}
                        title="Please enter a valid Review Description"
                    />
                    {inputValidationErrors && inputValidationErrors.message && (
                        <div className="invalid-data">{inputValidationErrors.message}</div>
                    )}
                </div>
            </div>

            {/* <div className="col-lg-12">
                <div className="form-group">
                    {formSubmitted && Object.values(newTestimonial).some(val => !val.trim()) && (
                        <div className="invalid-data">{ALL_FIELDS_ERROR_MESSAGE}</div>
                    )}
                </div>
            </div> */}

            <div className="col-lg-12">
                <div className="form-group">
                    <button
                        disabled={isLoading}
                        className={`rn-btn edu-btn w-100 ${isLoading ? 'btn-loading' : ''}`}
                        type="button"
                        onClick={handleSubmitTestimonial}
                    >
                        {isLoading ? (
                            <>
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                                Submitting...
                            </>
                        ) : (
                            <>
                                <span>Submit Review</span>
                                <i className="icon-arrow-right-line-right" />
                            </>
                        )}
                    </button>
                </div>
            </div>

            {result && (
                <div className="form-group">
                    <Result />
                </div>
            )}
        </div>
    );
}

export default Testimonial;
